const getBaseUrl = () => process.env.REACT_APP_BASE_API_URL || "/";



export const getCompanyId = () =>

  localStorage.getItem("companyid") ||

  localStorage.getItem("company_id") ||

  "";

// Identity for permission-gated routes; the proxy rejects them without it.
const getUserName = () => localStorage.getItem("userName") || "";



/** Key for kWh values in detect payload `metrics` / `previousMetrics` */

export const PURCHASED_ELECTRICITY_METRIC_KEY = "scope2-purchased_electricity";

const METRIC_KEY = PURCHASED_ELECTRICITY_METRIC_KEY;

function buildAnomalyQuery(params) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") {
      qs.set(key, String(value));
    }
  });
  return qs.toString();
}



export const isElectricityMetric = (esgMetric) =>

  (esgMetric || "").toLowerCase().includes("electric");



export const buildAnomalyId = (partitionKey, rowKey) =>

  `${partitionKey}_${rowKey}`;



export async function detectAnomalies(payload) {

  const res = await fetch(`${getBaseUrl()}api/anomaly/detect`, {

    method: "POST",

    headers: { "Content-Type": "application/json" },

    body: JSON.stringify({

      esgMetricKey: METRIC_KEY,

      billingPeriod: new Date().toISOString().slice(0, 7),

      metrics: { [METRIC_KEY]: 0 },

      ...payload,

    }),

  });

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.error || `Detect failed (${res.status})`);

  }

  return res.json();

}



export async function listAnomalies(companyId, siteLocation) {
  const qs = buildAnomalyQuery({ companyId, siteLocation });
  const res = await fetch(`${getBaseUrl()}api/anomaly/list?${qs}`);

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.error || err.message || `List failed (${res.status})`);

  }

  const data = await res.json();

  return data.anomalies || [];

}



export async function getBaseline(companyId, esgMetricKey = METRIC_KEY, siteLocation) {
  if (!siteLocation) return null;
  const qs = buildAnomalyQuery({ companyId, esgMetricKey, siteLocation });
  const res = await fetch(`${getBaseUrl()}api/anomaly/baseline?${qs}`);

  if (!res.ok) {

    return null;

  }

  return res.json();

}



export async function setAnomalyAcknowledged(anomalyId, acknowledged = true) {

  const res = await fetch(`${getBaseUrl()}api/anomaly/acknowledge`, {

    method: "POST",

    headers: { "Content-Type": "application/json", username: getUserName() },

    body: JSON.stringify({ anomalyId, acknowledged }),

  });

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.error || `Update failed (${res.status})`);

  }

  return res.json();

}



/** @deprecated use setAnomalyAcknowledged */

export async function acknowledgeAnomaly(anomalyId) {

  return setAnomalyAcknowledged(anomalyId, true);

}



/** Year-over-year / period-over-period detection is disabled for now (same-month only). */
export function isYearOverYearAnomaly(row) {
  const t = String(row?.anomalyType || row?.type || row?.AnomalyType || "").toLowerCase();
  return t === "period_over_period" || t === "year_over_year";
}

export function normalizeListAnomaly(row) {

  if (!row) return null;

  const expectedLower = row.expectedLower ?? row.ExpectedLower;

  const expectedUpper = row.expectedUpper ?? row.ExpectedUpper;

  const anomalyType = row.anomalyType || row.type || row.AnomalyType;

  const partitionKey = row.partitionKey || row.PartitionKey;

  const rowKey = row.rowKey || row.RowKey;

  const siteLocation = row.siteLocation || row.facility || row.SiteLocation || row.Facility;

  const esgMetricKey = row.esgMetricKey || row.metric || row.EsgMetricKey || row.Metric;

  const billingPeriod = row.billingPeriod || row.period || row.BillingPeriod || row.Period;

  return {

    id: buildAnomalyId(partitionKey, rowKey),

    partitionKey,

    rowKey,

    companyId: row.companyId || partitionKey,

    siteLocation,

    facility: siteLocation,

    esgMetricKey,

    metric: esgMetricKey,

    type: anomalyType,

    anomalyType,

    severity: row.severity || row.Severity,

    change: row.changePercent ?? row.change ?? 0,

    currentValue: row.currentValueKwh ?? row.currentValue ?? 0,

    previousValue: row.previousValueKwh ?? row.previousValue ?? 0,

    message: row.message,

    period: billingPeriod,

    billingPeriod,

    detectedAt: row.detectedAt,

    acknowledged: row.acknowledged === true,

    expectedRange:

      expectedLower != null && expectedUpper != null

        ? { lower: expectedLower, upper: expectedUpper }

        : null,

    median: row.median,

    historicalCount: row.historicalCount,

    iqrDistance: row.iqrDistance,

  };

}



export function extractElectricityFromStep4(step4) {

  if (!Array.isArray(step4)) return null;

  for (const item of step4) {

    const q = String(item?.question || item?.id || "").toLowerCase();

    const raw = item?.answer;

    if (raw == null || raw === "") continue;

    const num = parseFloat(String(raw).replace(/[^0-9.-]/g, ""));

    if (Number.isNaN(num)) continue;

    if (

      q.includes("electric") ||

      q.includes("purchased") ||

      String(item?.id || "").includes("e1")

    ) {

      return num;

    }

  }

  return null;

}



export async function runReportAnomalyCheck({ companyId, siteLocation, currentValue, previousValue }) {

  if (!companyId || !siteLocation || currentValue == null) {

    return null;

  }

  let previous = previousValue;

  if (previous == null || previous === 0) {

    const baselineRes = await getBaseline(companyId, METRIC_KEY, siteLocation);

    const baseline = baselineRes?.baseline;

    previous =

      baseline?.baselineValue ??

      baseline?.lastValue ??

      baseline?.BaselineValue ??

      0;

  }

  return detectAnomalies({

    companyId,

    siteLocation,

    esgMetricKey: METRIC_KEY,

    metrics: { [METRIC_KEY]: currentValue },

    previousMetrics: { [METRIC_KEY]: previous },

  });

}





// ========== Same-Month Baseline Detection API ==========



export async function detectSameMonthAnomalies({

  companyId,

  siteLocation,

  billingPeriod,

  currentValueKwh,

  billingDays = 30,

  historicalSameMonth = [],

}) {

  const res = await fetch(`${getBaseUrl()}api/anomaly/detect-same-month`, {

    method: "POST",

    headers: { "Content-Type": "application/json" },

    body: JSON.stringify({

      companyId,

      siteLocation,

      esgMetricKey: METRIC_KEY,

      billingPeriod,

      currentValueKwh,

      billingDays,

      historicalSameMonth,

    }),

  });

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.detail || err.error || `Same-month detection failed (${res.status})`);

  }

  return res.json();

}



export async function clearOpenAnomaliesForPeriods({ companyId, siteLocation, billingPeriods }) {

  if (!companyId || !siteLocation || !billingPeriods?.length) {

    return { deleted: 0 };

  }

  const res = await fetch(`${getBaseUrl()}api/anomaly/clear-periods`, {

    method: "POST",

    headers: { "Content-Type": "application/json", username: getUserName() },

    body: JSON.stringify({ companyId, siteLocation, billingPeriods }),

  });

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.detail || err.error || `Clear periods failed (${res.status})`);

  }

  return res.json();

}



export async function saveHistoricalData({

  companyId,

  siteLocation,

  billingPeriod,

  valueKwh,

  billingDays = 30,

}) {

  const res = await fetch(`${getBaseUrl()}api/anomaly/save-history`, {

    method: "POST",

    headers: { "Content-Type": "application/json", username: getUserName() },

    body: JSON.stringify({

      companyId,

      siteLocation,

      esgMetricKey: METRIC_KEY,

      billingPeriod,

      valueKwh,

      billingDays,

    }),

  });

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.detail || err.error || `Save history failed (${res.status})`);

  }

  return res.json();

}



export async function getHistorySpan(companyId, siteLocation, esgMetricKey = METRIC_KEY) {
  const qs = buildAnomalyQuery({ companyId, siteLocation, esgMetricKey });
  const res = await fetch(`${getBaseUrl()}api/anomaly/history-span?${qs}`);

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.detail || err.error || `Get history span failed (${res.status})`);

  }

  return res.json();

}



export async function getSameMonthHistory(companyId, siteLocation, targetMonth, esgMetricKey = METRIC_KEY) {
  const qs = buildAnomalyQuery({ companyId, siteLocation, esgMetricKey, targetMonth });
  const res = await fetch(`${getBaseUrl()}api/anomaly/same-month-history?${qs}`);

  if (!res.ok) {

    const err = await res.json().catch(() => ({}));

    throw new Error(err.detail || err.error || `Get same-month history failed (${res.status})`);

  }

  return res.json();

}



export function normalizeSameMonthAnomaly(anomaly) {

  if (!anomaly) return null;

  return {

    id: anomaly.id,

    type: anomaly.type,

    esgMetricKey: anomaly.esgMetricKey || anomaly.metric,

    metric: anomaly.esgMetricKey || anomaly.metric,

    severity: anomaly.severity,

    change: anomaly.change ?? 0,

    message: anomaly.message,

    detectedAt: anomaly.detectedAt,

    acknowledged: anomaly.acknowledged === true,

    iqrDistance: anomaly.iqrDistance,

    expectedRange: anomaly.expectedRange,

    currentDaily: anomaly.currentDailyKwh ?? anomaly.currentDaily,

    median: anomaly.median,

    historicalCount: anomaly.historicalCount,

  };

}



export function isInsufficientHistory(response) {

  return response?.status === "insufficient_history";

}

